import React, { PropsWithChildren } from "react";
import { canManageUnits } from "../common/helpers/municipalityRoles";
import MunicipalityRoleAuthorized from "./MunicipalityRoleAuthorized";

const AdminAuthorized = (props: PropsWithChildren<{}>) => (
    <MunicipalityRoleAuthorized
        canAccess={(user) => canManageUnits(user.municipalityRole)}
    >
        {props.children}
    </MunicipalityRoleAuthorized>
);

export default AdminAuthorized;
